export default __webpack_public_path__ + "static/media/Handi-Kho.bb28103c.jpg";